import React, { MouseEventHandler } from 'react';
import StringItemList from 'components/StringItemsList';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { IProject } from 'pages/Projects/Projects.types';
import { useTranslation } from 'react-i18next';

import {
  Button,
  List,
  ListItem,
  ListItemText,
  Modal,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';

interface ProjectModalProps {
  open: boolean;
  onClose: MouseEventHandler;
  project: IProject;
}
interface ModalItemProps {
  title: string;
  details: string;
}

const ModalItem: React.FunctionComponent<ModalItemProps> = ({
  title,
  details,
}) => {
  return (
    <Typography sx={{ mt: 2 }}>
      <Typography component='span' fontWeight='Medium'>
        {title}
      </Typography>{' '}
      {details}
    </Typography>
  );
};

const ProjectModal: React.FunctionComponent<ProjectModalProps> = ({
  open,
  onClose,
  project,
}) => {
  const { t } = useTranslation();
  const { height, width } = useWindowDimensions();
  const { icon, title, techStack, url, description, sourceCode, details } =
    project;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={[
          styles.box,
          {
            maxHeight: { xs: height * 0.85, sm: height * 0.6 },
            width: { xs: width * 0.75, sm: width * 0.6, md: 600 },
          },
        ]}
      >
        {width < 490 && (
          <Button sx={styles.closeButton} onClick={onClose}>
            X
          </Button>
        )}
        <Typography variant='h6'>
          {icon}{' '}
          <a href={url} target='_blank' rel='noreferrer'>
            {title}{' '}
          </a>
        </Typography>

        <ModalItem title={`${t('projects.techStack')}: `} details={techStack} />
        <ModalItem
          title={`${t('projects.sourceCode')}: `}
          details={sourceCode ?? 'Private'}
        />
        <ModalItem
          title={`${t('projects.description')}: `}
          details={description}
        />

        <StringItemList items={details} sx={{ py: 1 }} />
      </Box>
    </Modal>
  );
};

const styles = {
  box: {
    display: 'block',
    overflow: 'hidden',
    p: 3,
    position: 'fixed',
    zIndex: '100',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'white',
    boxShadow: 24,
    overflowY: 'auto',
  },
  closeButton: {
    position: 'relative',
    left: '85%',
    top: '20%',
  },
};

export default ProjectModal;
